import { ArticleBodyWrapper } from './ArticleBodyWrapper.tsx';

export function ArticleBody({ html }: { html: string }) {
  return (
    <ArticleBodyWrapper>
      {/* oxlint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: html }}></div>
    </ArticleBodyWrapper>
  );
}
